// eslint-disable-next-line import/prefer-default-export
export function smoothScroll(el) {
  if (!el || !el.scrollIntoView) return;

  el.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
}
